import * as React from 'react';

import * as Edge from '../../core';
import FormField from '../formField';

const TermsFormFields: React.FunctionComponent<{}> = (props) => (
	<>
		<FormField
			type="checkbox"
			name="wasAtLeast13YearsOldAtRegistration"
			description="I am at least 13 years old."
		/>
		<FormField
			type="checkbox"
			name="agreedToCookiesAtRegistration"
			description="I consent to the collection of cookies."
		/>
		<FormField
			type="checkbox"
			name="agreedToLicenseAgreementAtRegistration"
			description="I consent to the Privacy Policy."
			label={
				<>
					I consent to the{' '}
					<a
						href={Edge.Constants.URL_PRIVACY_POLICY}
						target="_blank"
						rel="noopener noreferrer"
						className="eula_link"
					>
						Privacy Policy
					</a>
					.
				</>
			}
		/>
	</>
);
export default TermsFormFields;
